module.exports = __webpack_public_path__ + "img/coach-avatar-example.54c781b6.png";